import { render, staticRenderFns } from "./CompanyLocationActionsButton.vue?vue&type=template&id=0495c80b&"
import script from "./CompanyLocationActionsButton.vue?vue&type=script&lang=js&"
export * from "./CompanyLocationActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports